import { ProjectStatus } from '../../../../responses/projects'

export const listStatusFilters: ProjectStatus[] = [
    ProjectStatus.NEW,
    ProjectStatus.IN_WORK,
    ProjectStatus.TO_CLOSE,
    ProjectStatus.PAUSED,
    ProjectStatus.CLOSED,
    ProjectStatus.CANCELED,
]